class Diagnostic {
  constructor() {
    this._cachedQuestion = {};
    this.activeQuestion = null;
    this.customerDataQuestionHandles = ["q0-pour-qui", "q1-nom-genre", "email"];
    this.initialQuestionHandle = "q0-pour-qui";
    this.data = {
      "answers": []
    };
    this.dataHistory = {};
    this.editData = {};
    this.localStorageKey = {
      progress: 'diagnostic-progress',
      result: 'diagnostic-result'
    };

    //The template could be defined as "full" or "mini". 
    //"full" is for the plain page diagnostic, "mini" is for the hub diagnostic
    this.template = "full";
    this.init();
  }
  init() {
    this.diagElem = document.querySelector('.diagnostic');
    this.customerId = this.diagElem.getAttribute('data-customer-id') ? parseInt(this.diagElem.getAttribute('data-customer-id')) : null;
    this.startScreen = this.diagElem.querySelector('#diagnostic-start');
    this.selections = JSON.parse(document.getElementById('diag-selections').innerText);
    let urlParams = new URLSearchParams(window.location.search);

    // Handle restart diag
    if (urlParams.has('restart')) {
      this.initStartScreen();
      localStorage.removeItem('diagnostic-progress');
      let url = new URL(window.location.href);
      url.searchParams.delete('restart');
      window.history.replaceState({}, document.title, url.toString());
      return;
    }

    // Handle edit diag
    if (urlParams.has('edit') && localStorage.getItem('diagnostic-edit-data')) {
      this.instanciateQuestion(this.initialQuestionHandle);
      localStorage.removeItem('diagnostic-progress');
      this.editData = JSON.parse(localStorage.getItem('diagnostic-edit-data'));
      return;
    } else {
      localStorage.removeItem('diagnostic-edit-data');
    }

    // Load progress and data from local storage
    let progressData = JSON.parse(localStorage.getItem(this.localStorageKey.progress));
    if (progressData !== null) {
      const now = new Date();
      const updatedAt = new Date(progressData.updatedAt);
      const hoursDifference = (now - updatedAt) / 36e5;
      const saveDuration = this.customerId ? 24 * 30 : 24; // 1 day for not logged in users, 30 days for logged in users

      if (hoursDifference <= saveDuration) {
        this.data = progressData.data;
        this.dataHistory = progressData.dataHistory;
        this.instanciateQuestion(progressData.activeQuestion);
      } else {
        localStorage.removeItem(this.localStorageKey.progress);
        this.initStartScreen();
      }
      return;
    }
    this.initStartScreen();
  }
  initStartScreen() {
    this.startScreen.style.display = 'flex';
    this.startScreen.querySelector('#start-button').addEventListener('click', () => {
      this.instanciateQuestion(this.initialQuestionHandle);
      this.startScreen.style.display = 'none';

      // Send the event to Google Analytics when the diagnostic is started
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'start_diagnostic_ta',
        diagnostic_name: 'main_diagnostic'
      });
    });

    // If a not logged in user has a recent diag result, display the link to access it
    const diagResult = JSON.parse(localStorage.getItem('diagnostic-result'));
    const linkElem = this.diagElem.querySelector('#diag-result-link');
    if (!this.customerId && diagResult && linkElem) {
      const diagDate = new Date(diagResult.diagnosticDate);
      const nowDate = new Date();
      const hoursDifference = (nowDate - diagDate) / 36e5; // Difference in hours

      if (hoursDifference <= 24) {
        linkElem.setAttribute('href', diagResult.resultURL);
        linkElem.style.display = "block";
      }
    }
  }
  instanciateQuestion(handle, answersData) {
    if (this.customerDataQuestionHandles.includes(handle)) {
      this.activeQuestion = new CustomerDataQuestion(handle, this, answersData);

      // Send the event to Google Analytics when the form is submitted and the email is filled
      if (handle === "email") {
        const customerDataForm = this.diagElem.querySelector('.customerDataForm');
        if (customerDataForm) {
          customerDataForm.addEventListener('submit', e => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'complete_email_diagnostic_ta',
              diagnostic_name: 'main_diagnostic',
              user_data: {
                email_address: this.data.email
              }
            });
          });
        }
      }
    } else {
      this.activeQuestion = new Question(handle, this, answersData);
    }

    // Save progress and data to local storage, except for the initial question
    if (handle !== this.initialQuestionHandle) {
      this._saveProgressToLocalStorage();
    }
  }
  async submitDiagnostic() {
    try {
      this.diagElem.querySelector('#diag-submit-error') ? this.diagElem.querySelector('#diag-submit-error').style.display = 'none' : null;
      this.diagElem.classList.add('is-loading');
      if (this.customerId) {
        this.data.customer_id = this.customerId;
      }
      const products = await this._getSelectionProducts();
      let saveData = {
        ...this.data,
        products
      };
      if (this.editData.length > 0) {
        // Pass the metaobject id to the save call if the user is editing a diagnostic
        let urlParams = new URLSearchParams(window.location.search);
        let metaobjectId = parseInt(urlParams.get('edit'));
        if (metaobjectId) {
          saveData = {
            metaobject_id: metaobjectId,
            ...saveData
          };
        } else {
          throw new Error('No metaobject id found during edit');
        }
      }

      // Send data to Clément and retrieve the result metaobject URL
      let response = await window.sendDiagData('save', saveData);
      if (!response.ok) {
        throw new Error('Error while submitting diagnostic data');
      }
      let data = await response.json();
      let resultPageUrl = `${window.links.diagResult}?diag=${data.handle}`;

      // Clear the local storage progress data now that the diagnostic is complete and the result page is created
      localStorage.removeItem(this.localStorageKey.progress);

      // If the user is not logged in, we store the result page URL in the local storage
      if (!this.customerId) {
        let resultData = {
          "diagnosticDate": new Date().toISOString(),
          "resultURL": resultPageUrl,
          "metaobjectId": data.id
        };
        localStorage.setItem(this.localStorageKey.result, JSON.stringify(resultData));
      }

      // Send the event to Google Analytics when the diagnostic is submitted
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'submit_diagnostic_ta',
        diagnostic_name: 'main_diagnostic',
        user_data: {
          email_address: this.data.email
        }
      });

      // Redirect to the result page
      window.location.href = resultPageUrl;
    } catch (error) {
      this.diagElem.classList.remove('is-loading');
      this.diagElem.querySelector('#diag-submit-error') ? this.diagElem.querySelector('#diag-submit-error').style.display = 'block' : null;
      console.error(error);
    }
  }
  _saveProgressToLocalStorage() {
    let progressData = {
      "updatedAt": new Date().toISOString(),
      "activeQuestion": this.activeQuestion.handle,
      "data": this.data,
      "dataHistory": this.dataHistory
    };
    localStorage.setItem(this.localStorageKey.progress, JSON.stringify(progressData));
  }
  _updateDataHistory() {
    this.dataHistory[this.activeQuestion.handle] = JSON.parse(JSON.stringify(this.data));
  }
  async _getSelectionProducts() {
    // Find the matched metaobject ID based on the answers
    let answersArray = this.data.answers.map(answer => answer.answer);
    let matchedSelections = this.selections.filter(selection => {
      // We use forloop instead of .every() so the loop breaks when it finds a non matching answer
      for (let selectionAnswer of selection.answers) {
        if (!answersArray.includes(selectionAnswer)) {
          return false;
        }
      }
      return true;
    });
    if (!matchedSelections.length > 0) {
      throw new Error('Selection metaobject not found: Unable to determine selection based on provided answers.');
    }

    /* PRIMARY NEEDS */
    const metaobject = await this._getMetaobjectData(`gid://shopify/Metaobject/${matchedSelections[0].metaobjectId}`);
    let selectionProducts = {};

    // Loop through the fields of the metaobject to extract the product data
    metaobject.fields.forEach(field => {
      const match = field.key.match(/(product|text|title)_(\d+)/);
      if (match) {
        const [_, type, index] = match;

        // If the product object doesn't exist yet, create it
        let product = selectionProducts[`product_${index}`] ?? (selectionProducts[`product_${index}`] = {});

        // Assign the values to the product_i object of the selectionProducts object
        switch (type) {
          case 'product':
            product.id = parseInt(field.value.split('/').pop());
            break;
          case 'title':
            product.title = field.value;
            break;
          case 'text':
            product.text = field.value;
            break;
          default:
            break;
        }
      }
    });

    /* SECONDARY NEEDS */
    let secondaryNeedsMetaobjectId = metaobject.fields.find(field => field.key == "secondary_needs_selection").value;
    const secondaryMetaobject = await this._getMetaobjectData(secondaryNeedsMetaobjectId);
    let secondaryAnswers = secondaryMetaobject.fields.filter(field => field.key.startsWith('answer_')).map(field => {
      const index = parseInt(field.key.split('_')[1]);
      return {
        index,
        value: field.reference.field.value
      };
    });

    // Check for secondary need product
    let secondaryProductIndexes = [];
    for (let i = 0; i < secondaryAnswers.length; i++) {
      if (answersArray.includes(secondaryAnswers[i].value)) {
        secondaryProductIndexes.push(secondaryAnswers[i].index); // i + 3 because the first 2 products are main products
      }
    }

    // Populate the selection products with the second need
    if (secondaryProductIndexes.length > 0) {
      secondaryMetaobject.fields.forEach(field => {
        const match = field.key.match(/(product|text|title)_(\d+)/);
        if (match) {
          const [_, type, index] = match;
          if (!secondaryProductIndexes.includes(parseInt(index))) {
            return;
          }

          // If the product object doesn't exist yet, create it
          let product = selectionProducts[`product_${index}`] ?? (selectionProducts[`product_${index}`] = {});

          // Assign the values to the product_i object of the selectionProducts object
          switch (type) {
            case 'product':
              product.id = parseInt(field.value.split('/').pop());
              break;
            case 'title':
              product.title = field.value;
              break;
            case 'text':
              product.text = field.value;
              break;
            default:
              break;
          }
        }
      });
    }

    /* console.log('Selection products :', selectionProducts); */

    return selectionProducts;
  }

  // Fetch a specific metaobject data with the Storefront API
  async _getMetaobjectData(gid) {
    const query = `
            query GetMetaobject($id: ID!) {
                metaobject(id: $id) {
                    id
                    handle
                    fields {
                        key
                        value
                        reference {
                            ... on Metaobject {
                                id
                                field(key: "value") {
                                    value
                                }
                            }
                        }
                    }
                }
            }
        `;
    const variables = {
      id: gid
    };
    const response = await fetch(`https://${Shopify.shop}/api/2024-07/graphql.json`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Shopify-Storefront-Access-Token": "21834167fc74a1c6402fb381904b8e82"
      },
      body: JSON.stringify({
        query,
        variables
      })
    });
    const responseData = await response.json();
    return responseData.data.metaobject;
  }
}